export default {
  NaoIniciado: 1,
  EmAndamento: 2,
  Concluido: 3,
  Cancelado: 4,
  Falho: 5,
};
